import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import capitalizeString from 'utils/capitalize'
import {
  KbaCriteriaSummaryWrapper,
  KbaCriteriaSummaryLine,
  KbaCriteriaSummaryLabel,
  KbaCriteriaSummaryValues,
  KbaCriteriaChip
} from './style'

const sortCriteria = (criteria = []) => {
  if (!Array.isArray(criteria) || criteria.length === 0) {
    return []
  }

  return [...criteria]
    .map((item) => capitalizeString(item))
    .filter(Boolean)
    .sort((a, b) => {
      if (a < b) {
        return -1
      }
      if (a > b) {
        return 1
      }
      return 0
    })
}

/**
 * Displays the KBA criteria met across all triggers at the top of
 * the Assessment and Criteria met tabs.
 */
const KbaCriteriaSummary = ({ criteria = [], isLoading = false, marginTop }) => {
  const displayCriteria = useMemo(() => sortCriteria(criteria), [criteria])

  if (isLoading || displayCriteria.length === 0) {
    return null
  }

  return (
    <KbaCriteriaSummaryWrapper
      data-testid="kba-criteria-summary"
      data-test="kba-criteria-summary"
      marginTop={marginTop}
    >
      <KbaCriteriaSummaryLine>
        <KbaCriteriaSummaryLabel>
          <FormattedMessage id="kbaCriteriaMetOverall" />:
        </KbaCriteriaSummaryLabel>
        <KbaCriteriaSummaryValues
          data-testid="kba-criteria-summary-value"
          aria-label={displayCriteria.join(', ')}
        >
          {displayCriteria.map((criterion) => (
            <KbaCriteriaChip key={criterion} data-testid={`kba-criteria-chip-${criterion}`}>
              {criterion}
            </KbaCriteriaChip>
          ))}
        </KbaCriteriaSummaryValues>
      </KbaCriteriaSummaryLine>
    </KbaCriteriaSummaryWrapper>
  )
}

KbaCriteriaSummary.propTypes = {
  criteria: PropTypes.arrayOf(PropTypes.string),
  isLoading: PropTypes.bool,
  marginTop: PropTypes.string
}

export default KbaCriteriaSummary
